import { omit } from 'lodash-es'

import { parseQueryString, stringifyQueryString } from '@fv/client-core'

const defaultExcludeKeys = ['limit', 'skip', 'continuationToken', 'page']

/**
 * Produces a stable, sorted query string for use as a cache key.
 * Excludes params that shouldn't affect cache identity (pagination, etc.).
 */
export function normalizeQueryString(
  qs: string,
  excludeKeys: readonly string[] = [],
) {
  const parsed = omit(
    parseQueryString(qs),
    ...defaultExcludeKeys,
    ...excludeKeys,
  )
  return stringifyQueryString(Object.fromEntries(Object.entries(parsed).sort()))
}

export const ORIGIN_LOCATION_NAMES = [
  'originAccount[]',
  'originCity[]',
  'originState[]',
  'originZip[]',
  'originCountry[]',
] as const

export const DEST_LOCATION_NAMES = [
  'destAccount[]',
  'destCity[]',
  'destState[]',
  'destZip[]',
  'destCountry[]',
] as const
